import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'public/environments/environment';
import { AddUserModel } from '../models/add-user';
import { RefreshActionEnum } from '../../models/enums/RefreshActionEnum';

@Injectable({
  providedIn: 'root'
})
export class ConsumerAmbassadorService {
  refreshList = new BehaviorSubject<RefreshActionEnum | boolean>(false);
  closeDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/ConsumerAmbassador/ListConsumerAmbassadorsUsers`, { params });
  }

  addUser(data: any, userId?: any) {
    if (userId) {
      return this.http.put(`${environment.apiUrl}/ConsumerAmbassador/UpdateConsumerAmbassador`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/ConsumerAmbassador/AddConsumerAmbassador`, data);
    }
  }
  saveUser(user: AddUserModel, fileToUpload: any) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(user));
    if (fileToUpload && fileToUpload.name) {
      formData.append('files', fileToUpload, fileToUpload.name);
    }
    if (user.userId) {
      return this.http.put(`${environment.apiUrl}/ConsumerAmbassador/UpdateConsumerAmbassador`, formData);
    } else {
      return this.http.post(`${environment.apiUrl}/ConsumerAmbassador/AddConsumerAmbassador`, formData);
    }
  }
  getConsumerAmbassadorUserDetails(id: any) {
    return this.http.get(`${environment.apiUrl}/ConsumerAmbassador/GetConsumerAmbassadorUserDetails?id=${id}`);
  }

  deleteUser(id: any) {
    return this.http.delete(`${environment.apiUrl}/ConsumerAmbassador/DeleteConsumerAmbassador?id=${id}`);
  }


  changeStatus(id: any, status: any) {
    return this.http.get(`${environment.apiUrl}/ConsumerAmbassador/ChangeConsumerAmbassadorUserStatus?id=${id}&status=${status}`);
  }

  resendVerification(id: any) {
    return this.http.get(`${environment.apiUrl}/ConsumerAmbassador/ReSendActivationEmail?id=${id}`);
  }


}
